import React from "react";
import { titles } from "constants/titles";
import CustomButton from "components/widgets/custom-button/CustomButton";
import { convertInRequiredTimeZone } from "utility";

const CaregiverTrackingCard = ({
  deviceLocation,
  customSchemaForUI,
  onCaregavireTracking,
  onLocationHistory,
  selectedDeviceDetails,
  selectedMedicalUser,
  currentTimeZone
}) => {
  return (
    <div className="dp_caregiver_card">
      <h3 className="dp_caregiver_title">
        {titles?.caregiver_tracking}
      </h3>

      {customSchemaForUI?.dataTimeStamp && (
        <p className="dp_map_info">
          {`${titles?.map_information} ${convertInRequiredTimeZone(
            customSchemaForUI?.dataTimeStamp,
            selectedMedicalUser?.timezone,
            currentTimeZone
          )}`}
        </p>
      )}

      <div className="dp_map_container">
        {!deviceLocation?.latitude ? (
          <div className="dp_empty_map">
            <p className="dp_empty_map_text">
              {titles?.fetching_location}
            </p>
          </div>
        ) : (
          <iframe
            src={`https://maps.google.com/maps?q=${deviceLocation?.latitude},${deviceLocation?.longitude}&z=15&output=embed`}
            width="100%"
            height="180"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="gmap"
            className="dp_map_iframe"
          />
        )}
      </div>

      <div className="dp_caregiver_buttons">
        <CustomButton
          text={titles?.see_map}
          width="100%"
          disabled={!deviceLocation?.latitude}
          className="dp_see_map_button"
          onClick={() => onCaregavireTracking()}
        />

        {selectedDeviceDetails?.is_show_location_history ? (
          <CustomButton
            text={titles?.location_history}
            width="100%"
            className="dp_location_history_button"
            onClick={() => onLocationHistory()}
          />
        ) : null}
      </div>
    </div>
  );
};

export default CaregiverTrackingCard;
